import { Pipe, PipeTransform } from '@angular/core';
import { CommonUtilService } from '../../services/CommonUtil.service';

@Pipe({
    name: 'revenueValue',
    standalone: false
})
export class RevenueValuePipe implements PipeTransform {
    constructor(private readonly commonUtilService: CommonUtilService) {
    }
    transform(value: any): any {
        return this.commonUtilService.getRevenueValue(value);
    }
}
